import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setIsPublic as setLayoutIsPublic
} from '../redux/layouts'

export default function * requestSetLayoutAsPublic (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut(setLayoutIsPublic({
    id,
    isPublic: true
  }))

  try {
    yield call(apiAction, 'SetHomeLayoutAsPublic', {
      layoutId: id
    })
  } finally {
    yield optimisticAction.revert()
  }
}
